/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Switch, Text, Title, Checkbox } from 'components';
import ContactModalContext from './ContactModalContext';

const Permissions: React.FC = () => {
  const { contact, setContact } = useContext(ContactModalContext);

  return (
    <StyledPermissionsSection>
      <div>
        <Title level={2}>Permissions</Title>
        <StyledPermissionsContainer>
          <StyledSwitchContainer>
            <Switch
              checked={contact.canConfirmAppts}
              onChange={canConfirmAppts => {
                setContact({ ...contact, canConfirmAppts });
              }}
            />{' '}
            <Text strong>Can Confirm</Text>
          </StyledSwitchContainer>
          <StyledSwitchContainer>
            <Switch
              checked={contact.canDenyAppts}
              onChange={canDenyAppts => {
                setContact({
                  ...contact,
                  canDenyAppts,
                  canSuggestTime: canDenyAppts ? contact.canDenyAppts : false,
                });
              }}
            />{' '}
            <Text strong>Can Deny/Cancel</Text>
          </StyledSwitchContainer>
          {contact.canDenyAppts && (
            <Checkbox
              checked={contact.canSuggestTime}
              onChange={e => {
                setContact({ ...contact, canSuggestTime: e.target.checked });
              }}
            >
              <Text strong>Allow this contact to soft suggest time</Text>
            </Checkbox>
          )}
        </StyledPermissionsContainer>
      </div>
    </StyledPermissionsSection>
  );
};

export default Permissions;

const StyledPermissionsSection = styled.div`
  display: grid;
  gap: 16px;
`;
const StyledPermissionsContainer = styled.div`
  display: grid;
  gap: 12px;
`;

const StyledSwitchContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto 1fr;
  width: auto;
`;
